import { createContext } from 'react';

const languageContext = createContext();

export default languageContext;
